var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { DottedLine } from '@shapeable/ui';
import { GptOutputContent } from './gpt-output-content';
import { GptOutputHeader } from './gpt-output-header';
import { classNames } from '@shapeable/utils';
import AnimateHeight from 'react-animate-height';
var cls = classNames('gpt-output-item');
export var GptOutputItemDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    &:hover {\n      background-color: ", ";\n    }\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    &:hover {\n      background-color: ", ";\n    }\n  "])), theme.COLOR('hover'))
});
var GptOutputHeaderStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DottedLineStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var GptOutputContentStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  GptOutputHeader: styled(GptOutputHeader)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), GptOutputHeaderStyles),
  DottedLine: styled(DottedLine)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), DottedLineStyles),
  GptOutputContent: styled(GptOutputContent)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), GptOutputContentStyles)
};
export var GptOutputItem = function (props) {
  var className = props.className,
    message = props.message;
  var _a = __read(React.useState(true), 2),
    isExpanded = _a[0],
    setIsExpanded = _a[1];
  var toggleExpand = function () {
    setIsExpanded(!isExpanded);
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Layout, null, React.createElement(My.GptOutputHeader, {
    onClick: toggleExpand,
    isExpanded: isExpanded,
    prompt: message.prompt
  }), React.createElement(AnimateHeight, {
    duration: 200,
    height: isExpanded ? 'auto' : 0
  }, React.createElement(My.GptOutputContent, {
    sources: message.responseSources,
    text: message.response,
    onCollapseClick: toggleExpand,
    activeLanguage: message.language
  }))));
};
GptOutputItem.cls = cls;
GptOutputItem.defaultProps = GptOutputItemDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;